import { MessagingPlatform } from '@this+that/models';

import { guardedIntegrationFetch } from './guardedIntegrationFetch';
import { useGetTeamSlackIntegrations } from '../../services/slack.service';
import { useIntegrationsStore } from '../../store';

export const useGetTeamSlackBotIntegrations = () => {
  const { getTeamSlackIntegrations } = useGetTeamSlackIntegrations();
  const { setTeamSlackBotIntegrations } = useIntegrationsStore();

  const handleFetchTeamSlackBotIntegrations = (
    teamId: string,
    forceRefresh = false,
  ) =>
    guardedIntegrationFetch({
      key: MessagingPlatform.SLACK_BOT,
      scope: teamId,
      forceRefresh,
      fetch: () => getTeamSlackIntegrations(teamId),
      write: setTeamSlackBotIntegrations,
    });

  return { handleFetchTeamSlackBotIntegrations };
};
